import React from 'react';

/**
 * 统一的页面标题组件
 * @param {String} title - 标题文本
 */
const PageTitle = ({ title }) => {
  return (
    <h2 style={{ 
      marginBottom: '20px', 
      fontSize: '18px', 
      fontWeight: 600, 
      color: '#1E293B', 
      marginTop: 0,
      lineHeight: 1.4,
      letterSpacing: '0.3px',
      position: 'relative',
      paddingLeft: '16px',
    }}>
      {title}
      <div style={{
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        background: '#3366FF',
        borderRadius: '2px',
      }} />
    </h2>
  );
};

export default PageTitle;

